export const isVisibleByPrivilegeCode = (code, item) => {
  if (code === "admin") {
    return true;
  } else {
    return item.privilege === code;
  }
};
